/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateOrderBody,
  Error,
  GetOrders200,
  GetOrdersParams,
  Order,
  UpdateOrderBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a new order manually or from an external source.
 * @summary Create a new order
 */
export type createOrderResponse201 = {
  data: Order
  status: 201
}

export type createOrderResponse400 = {
  data: Error
  status: 400
}

export type createOrderResponse401 = {
  data: Error
  status: 401
}

export type createOrderResponse403 = {
  data: Error
  status: 403
}

export type createOrderResponse404 = {
  data: Error
  status: 404
}

export type createOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type createOrderResponse500 = {
  data: Error
  status: 500
}

export type createOrderResponseSuccess = (createOrderResponse201) & {
  headers: Headers;
};
export type createOrderResponseError = (createOrderResponse400 | createOrderResponse401 | createOrderResponse403 | createOrderResponse404 | createOrderResponse422 | createOrderResponse500) & {
  headers: Headers;
};

export type createOrderResponse = (createOrderResponseSuccess | createOrderResponseError)

export const getCreateOrderUrl = () => {


  

  return `/orders`
}

export const createOrder = async (createOrderBody: CreateOrderBody, options?: RequestInit): Promise<createOrderResponse> => {
  
  return customFetch<createOrderResponse>(getCreateOrderUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrderBody,)
  }
);}
  

/**
 * Retrieve a paginated list of orders with optional filtering and sorting.
 * @summary List all orders
 */
export type getOrdersResponse200 = {
  data: GetOrders200
  status: 200
}

export type getOrdersResponse400 = {
  data: Error
  status: 400
}

export type getOrdersResponse401 = {
  data: Error
  status: 401
}

export type getOrdersResponse403 = {
  data: Error
  status: 403
}

export type getOrdersResponse404 = {
  data: Error
  status: 404
}

export type getOrdersResponse500 = {
  data: Error
  status: 500
}

export type getOrdersResponseSuccess = (getOrdersResponse200) & {
  headers: Headers;
};
export type getOrdersResponseError = (getOrdersResponse400 | getOrdersResponse401 | getOrdersResponse403 | getOrdersResponse404 | getOrdersResponse500) & {
  headers: Headers;
};

export type getOrdersResponse = (getOrdersResponseSuccess | getOrdersResponseError)

export const getGetOrdersUrl = (params?: GetOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orders?${stringifiedParams}` : `/orders`
}

export const getOrders = async (params?: GetOrdersParams, options?: RequestInit): Promise<getOrdersResponse> => {
  
  return customFetch<getOrdersResponse>(getGetOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single order by its unique identifier.
 * @summary Get order by ID
 */
export type getOrderByIdResponse200 = {
  data: Order
  status: 200
}

export type getOrderByIdResponse401 = {
  data: Error
  status: 401
}

export type getOrderByIdResponse403 = {
  data: Error
  status: 403
}

export type getOrderByIdResponse404 = {
  data: Error
  status: 404
}

export type getOrderByIdResponse500 = {
  data: Error
  status: 500
}

export type getOrderByIdResponseSuccess = (getOrderByIdResponse200) & {
  headers: Headers;
};
export type getOrderByIdResponseError = (getOrderByIdResponse401 | getOrderByIdResponse403 | getOrderByIdResponse404 | getOrderByIdResponse500) & {
  headers: Headers;
};

export type getOrderByIdResponse = (getOrderByIdResponseSuccess | getOrderByIdResponseError)

export const getGetOrderByIdUrl = (id: string,) => {


  

  return `/orders/${id}`
}

export const getOrderById = async (id: string, options?: RequestInit): Promise<getOrderByIdResponse> => {
  
  return customFetch<getOrderByIdResponse>(getGetOrderByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing order. Only the provided fields will be updated.
 * @summary Update an order
 */
export type updateOrderResponse200 = {
  data: Order
  status: 200
}

export type updateOrderResponse400 = {
  data: Error
  status: 400
}

export type updateOrderResponse401 = {
  data: Error
  status: 401
}

export type updateOrderResponse403 = {
  data: Error
  status: 403
}

export type updateOrderResponse404 = {
  data: Error
  status: 404
}

export type updateOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type updateOrderResponse500 = {
  data: Error
  status: 500
}

export type updateOrderResponseSuccess = (updateOrderResponse200) & {
  headers: Headers;
};
export type updateOrderResponseError = (updateOrderResponse400 | updateOrderResponse401 | updateOrderResponse403 | updateOrderResponse404 | updateOrderResponse422 | updateOrderResponse500) & {
  headers: Headers;
};

export type updateOrderResponse = (updateOrderResponseSuccess | updateOrderResponseError)

export const getUpdateOrderUrl = (id: string,) => {


  

  return `/orders/${id}`
}

export const updateOrder = async (id: string,
    updateOrderBody: UpdateOrderBody, options?: RequestInit): Promise<updateOrderResponse> => {
  
  return customFetch<updateOrderResponse>(getUpdateOrderUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrderBody,)
  }
);}
  

/**
 * Soft delete an order by its unique identifier.
 * @summary Delete an order
 */
export type deleteOrderResponse204 = {
  data: void
  status: 204
}

export type deleteOrderResponse400 = {
  data: Error
  status: 400
}

export type deleteOrderResponse401 = {
  data: Error
  status: 401
}

export type deleteOrderResponse403 = {
  data: Error
  status: 403
}

export type deleteOrderResponse404 = {
  data: Error
  status: 404
}

export type deleteOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteOrderResponse500 = {
  data: Error
  status: 500
}

export type deleteOrderResponseSuccess = (deleteOrderResponse204) & {
  headers: Headers;
};
export type deleteOrderResponseError = (deleteOrderResponse400 | deleteOrderResponse401 | deleteOrderResponse403 | deleteOrderResponse404 | deleteOrderResponse422 | deleteOrderResponse500) & {
  headers: Headers;
};

export type deleteOrderResponse = (deleteOrderResponseSuccess | deleteOrderResponseError)

export const getDeleteOrderUrl = (id: string,) => {


  

  return `/orders/${id}`
}

export const deleteOrder = async (id: string, options?: RequestInit): Promise<deleteOrderResponse> => {
  
  return customFetch<deleteOrderResponse>(getDeleteOrderUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Process a pending order: resolve or create customer, generate invoice, and optionally record payment.
 * @summary Process an order into an invoice
 */
export type processOrderResponse200 = {
  data: Order
  status: 200
}

export type processOrderResponse400 = {
  data: Error
  status: 400
}

export type processOrderResponse401 = {
  data: Error
  status: 401
}

export type processOrderResponse403 = {
  data: Error
  status: 403
}

export type processOrderResponse404 = {
  data: Error
  status: 404
}

export type processOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type processOrderResponse500 = {
  data: Error
  status: 500
}

export type processOrderResponseSuccess = (processOrderResponse200) & {
  headers: Headers;
};
export type processOrderResponseError = (processOrderResponse400 | processOrderResponse401 | processOrderResponse403 | processOrderResponse404 | processOrderResponse422 | processOrderResponse500) & {
  headers: Headers;
};

export type processOrderResponse = (processOrderResponseSuccess | processOrderResponseError)

export const getProcessOrderUrl = (id: string,) => {


  

  return `/orders/${id}/process`
}

export const processOrder = async (id: string, options?: RequestInit): Promise<processOrderResponse> => {
  
  return customFetch<processOrderResponse>(getProcessOrderUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Cancel a pending order. Already invoiced orders cannot be cancelled.
 * @summary Cancel an order
 */
export type cancelOrderResponse200 = {
  data: Order
  status: 200
}

export type cancelOrderResponse400 = {
  data: Error
  status: 400
}

export type cancelOrderResponse401 = {
  data: Error
  status: 401
}

export type cancelOrderResponse403 = {
  data: Error
  status: 403
}

export type cancelOrderResponse404 = {
  data: Error
  status: 404
}

export type cancelOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type cancelOrderResponse500 = {
  data: Error
  status: 500
}

export type cancelOrderResponseSuccess = (cancelOrderResponse200) & {
  headers: Headers;
};
export type cancelOrderResponseError = (cancelOrderResponse400 | cancelOrderResponse401 | cancelOrderResponse403 | cancelOrderResponse404 | cancelOrderResponse422 | cancelOrderResponse500) & {
  headers: Headers;
};

export type cancelOrderResponse = (cancelOrderResponseSuccess | cancelOrderResponseError)

export const getCancelOrderUrl = (id: string,) => {


  

  return `/orders/${id}/cancel`
}

export const cancelOrder = async (id: string, options?: RequestInit): Promise<cancelOrderResponse> => {
  
  return customFetch<cancelOrderResponse>(getCancelOrderUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Credit the existing invoice and create a new one with current order items. Only available when order items have changed after initial processing.
 * @summary Reissue an order invoice
 */
export type reissueOrderResponse200 = {
  data: Order
  status: 200
}

export type reissueOrderResponse400 = {
  data: Error
  status: 400
}

export type reissueOrderResponse401 = {
  data: Error
  status: 401
}

export type reissueOrderResponse403 = {
  data: Error
  status: 403
}

export type reissueOrderResponse404 = {
  data: Error
  status: 404
}

export type reissueOrderResponse422 = {
  data: ValidationError
  status: 422
}

export type reissueOrderResponse500 = {
  data: Error
  status: 500
}

export type reissueOrderResponseSuccess = (reissueOrderResponse200) & {
  headers: Headers;
};
export type reissueOrderResponseError = (reissueOrderResponse400 | reissueOrderResponse401 | reissueOrderResponse403 | reissueOrderResponse404 | reissueOrderResponse422 | reissueOrderResponse500) & {
  headers: Headers;
};

export type reissueOrderResponse = (reissueOrderResponseSuccess | reissueOrderResponseError)

export const getReissueOrderUrl = (id: string,) => {


  

  return `/orders/${id}/reissue`
}

export const reissueOrder = async (id: string, options?: RequestInit): Promise<reissueOrderResponse> => {
  
  return customFetch<reissueOrderResponse>(getReissueOrderUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

